import icDelete from '@/assets/img/icon/ic-delete.svg';
import icEdit from '@/assets/img/icon/ic-edit.svg';
import icRename from '@/assets/img/icon/ic-rename.svg';
import icMove from '@/assets/img/icon/ic-move.svg';
import icSearch from '@/assets/img/icon/ic-search.svg';
import icAddWhite from '@/assets/img/icon/ic-add-white.svg';
import icAddBlue from '@/assets/img/icon/ic-add-blue.svg';
import icUnPin from '@/assets/img/icon/ic-unpin.svg';
import icFiledownload from '@/assets/img/icon/ic-filedownload.svg';
import icFiledownloadBlue from '@/assets/img/icon/ic-filedownload-blue.svg';
import icAddGray from '@/assets/img/icon/ic-add-gray.svg';
import icClose from '@/assets/img/icon/ic-close.svg';
import icPack from '@/assets/img/icon/ic-pack.svg';
import icPrice from '@/assets/img/icon/ic-price.svg';
import icPriceGray from '@/assets/img/icon/ic-price-gray.svg';
import icVideo from '@/assets/img/icon/ic-video.svg';
import icAddPack from '@/assets/img/icon/ic-add-pack.svg';
import icAddPhoto from '@/assets/img/icon/ic-add-photo.png';
import icSave from '@/assets/img/icon/ic-save.svg';
import icSaveWhite from '@/assets/img/icon/ic-save-white.svg';
import icSelectBlue from '@/assets/img/icon/ic-select-blue.svg';
import icTipGray from '@/assets/img/icon/ic-tip-gray.svg';
import icTipBlue from '@/assets/img/icon/ic-tip-blue.svg';
import icCheck from '@/assets/img/icon/ic-check.svg';
import icCheckActive from '@/assets/img/icon/ic-check-active.svg';
import icTranslation from '@/assets/img/icon/ic-translation.svg';
import icProfile from '@/assets/img/icon/ic-profile.svg';
import icHelp from '@/assets/img/icon/ic-help.svg';
import icUploadPack from '@/assets/img/icon/ic-upload-pack.svg';
import icAdditionalBrandList from '@/assets/img/icon/ic-additional-brand-list.svg';
import icSelect from '@/assets/img/icon/ic-select.svg';
import icSad from '@/assets/img/icon/ic-sad.svg';
import icNext from '@/assets/img/icon/ic-next.svg';
import icOrder from '@/assets/img/icon/ic-order.svg';
import icBank from '@/assets/img/icon/ic-bank.svg';
import icInternetBanking from '@/assets/img/icon/ic-internet-banking.svg';
import icQR from '@/assets/img/icon/ic-QR.svg';
import icTag from '@/assets/img/icon/ic-tag.svg';
import icCreditDebit from '@/assets/img/icon/ic-credit-debit.svg';
import icTip from '@/assets/img/icon/ic-tip.svg';
import imgOrder from '@/assets/img/img-order.svg';
import imgPayment from '@/assets/img/img-payment-completed.svg';
import icError from '@/assets/img/icon/ic-error.svg';
import icLogout from '@/assets/img/icon/ic-logout.svg';
import icShowGray from '@/assets/img/icon/ic-show-gray.svg';
import icTabGray from '@/assets/img/icon/ic-tab-gray.svg';
import icTabGreen from '@/assets/img/icon/ic-tab-green.svg';
import icHomeMobile from '@/assets/img/icon/ic-home-mobile.svg';
import icNextMobile from '@/assets/img/icon/ic-next-gray.svg';
import icAdditionalAttributes from '@/assets/img/icon/ic-additional-attributes.svg';
import icReadMore from '@/assets/img/icon/ic-read-more.svg';
import icTicked from '@/assets/img/icon/ic-ticked.svg';
import icReadMoreGray from '@/assets/img/icon/ic-read-more-gray.svg';
import icTick from '@/assets/img/icon/ic-tick.svg';
import icMore from '@/assets/img/icon/ic-more.svg';
import icPowerPoint from '@/assets/img/icon/ic-powerpoint.svg';
import icExcel from '@/assets/img/icon/ic-excel.svg';
import icWord from '@/assets/img/icon/ic-word.svg';
import icPdf from '@/assets/img/icon/ic-pdf.svg';
import icArrowLogin from '@/assets/img/icon/ic-arrow-login.svg';
import icArrowRegister from '@/assets/img/icon/ic-arrow-register.svg';
import icView from '@/assets/img/icon/ic-view.svg';
import icInvoice from '@/assets/img/icon/ic-invoice.svg';
import icContract from '@/assets/img/icon/ic-contract.svg';
import icRestore from '@/assets/img/icon/ic-restore.svg';
import icEditCell from '@/assets/img/icon/ic-edit-cell.svg';
import imgPaymentFailed from '@/assets/img/img-payment-failed.svg';
import icDrag from '@/assets/img/icon/ic-drag.svg';
import icOpenQuestion from '@/assets/img/icon/ic-open-question.svg';
import icSingleChoice from '@/assets/img/icon/ic-single-choice.png';
import icMultipleChoices from '@/assets/img/icon/ic-multiple-choices.svg';
import icNumbericScale from '@/assets/img/icon/ic-numberic-scale.svg';
import icSmileyRating from '@/assets/img/icon/ic-smiley-rating.svg';
import icStarRating from '@/assets/img/icon/ic-star-rating.svg';
import icDeleteAnswer from '@/assets/img/icon/ic-delete-answer.svg';
import imgPaymentPending from '@/assets/img/img-payment-pending.svg';
import imgLangVi from '@/assets/img/lang-vi.png';
import imgLangEn from '@/assets/img/lang-en.png';
import imgLangId from '@/assets/img/lang-id.png';
import imgVisa from '@/assets/img/visa.png';
import imgJCB from '@/assets/img/jcb.png';
import imgMastercard from '@/assets/img/mastercard.png';
import imgAmericanExpress from '@/assets/img/american-express.png';
import imgUnionpay from '@/assets/img/unionpay.png';
import imgLaugh from '@/assets/img/icon/laugh.svg';
import imgSmile from '@/assets/img/icon/smile.svg';
import imgMeh from '@/assets/img/icon/meh.svg';
import imgSad from '@/assets/img/icon/sad.svg';
import imgPain from '@/assets/img/icon/pain.svg';
import imgTargetTabLocation from '@/assets/img/target-tab-location.svg';
import imgTargetTabAC from '@/assets/img/target-tab-ac.svg';
import imgTargetTabHI from '@/assets/img/target-tab-hi.svg';
import imgNoResultNotPay from '@/assets/img/no-result-not-pay.svg';
import imgNoResultPaid from '@/assets/img/no-result-paid.svg';
import icPaymentHistory from "@/assets/img/icon/ic-payment-history.svg";
import imgPaymentError1 from "@/assets/img/img-payment-error-1.svg";
import imgSupportAgent from "@/assets/img/img-support_agent.svg";
import imgDashboardReady from "@/assets/img/img-dashboard-ready.svg";
import imgProjectScheduled from "@/assets/img/img-project-scheduled.svg";
import imgFieldworkInProgress from "@/assets/img/img-fieldwork-in-progress.svg";
import imgPriceTestProduct from "@/assets/img/img-price-test-product.svg"
import imgPriceTestService from "@/assets/img/img-price-test-service.svg"
import imgPriceTestProductImageExample from "@/assets/img/img-price-test-product-image-example.png";
import imgPriceTestServiceImageExample from "@/assets/img/img-price-test-service-image-example.png";
import imgUploadFile from "@/assets/img/img-upload.svg";
import imgFileCsv from "@/assets/img/img-filecsv.svg";
import imgFileCsv2 from "@/assets/img/img-filecsv2.svg";
import imgPaymentSurvey from '@/assets/img/img-payment_survey_coplete.svg';
import imgPaymentSurveyFail from '@/assets/img/img-payment_survey_fail.svg';
import icLiveSurvey from '@/assets/img/ic-live_survey.svg';
import icSupportAgent from '@/assets/img/icon/ic-support_agent.svg';
import icSurveyCompleted from '@/assets/img/icon/ic-survey_completed.svg';
import placeholderLogo from '@/assets/img/placeholder_logo.png'
import icFreeText from '@/assets/img/icon-freetext.png'
import icLongText from '@/assets/img/icon-longtext.png'
import icNumber from '@/assets/img/icon-number.png'
import imgThankYou from '@/assets/img/thank_image.svg';
import starIcon from '@/assets/img/star_icon.svg';
import tagIcon from '@/assets/img/tag_icon.svg';
import agreementIcon from '@/assets/img/agreement_icon.svg';
import importanceIcon from '@/assets/img/importance_icon.svg';
import likelihoodIcon from '@/assets/img/likelihood_icon.svg';
import fivePointsIcon from '@/assets/img/5_points_icon.svg';
import sevenPointsIcon from '@/assets/img/7_points_icon.svg';
import tenPointsIcon from '@/assets/img/10_points_icon.svg';
import imgSorry from '@/assets/img/sorry_img.png';
import basicAvatar from "@/assets/img/avatar-basic.png";
import placeholderImage from '@/assets/img/placeholderImage.jpg';

const images = {
    // ===================== Images =========================
    imgNoResultNotPay,
    imgNoResultPaid,
    imgTargetTabLocation,
    imgTargetTabAC,
    imgTargetTabHI,
    imgVisa,
    imgJCB,
    imgMastercard,
    imgAmericanExpress,
    imgUnionpay,
    icInternetBanking,
    icQR,
    icTag,
    icCreditDebit,
    imgLangVi,
    imgLangEn,
    imgLangId,
    icEditCell,
    icRestore,
    icInvoice,
    icContract,
    icPdf,
    icView,
    icPowerPoint,
    icExcel,
    icWord,
    icOrder,
    icMore,
    icTicked,
    icReadMoreGray,
    icTick,
    icReadMore,
    icHomeMobile,
    icNextMobile,
    icTabGray,
    icTabGreen,
    icLogout,
    icShowGray,
    icError,
    icBank,
    icDelete,
    icTip,
    icEdit,
    icMove,
    icRename,
    icSearch,
    icAddWhite,
    icAddBlue,
    icUnPin,
    icFiledownload,
    icAddGray,
    icClose,
    icPack,
    icPrice,
    icPriceGray,
    icVideo,
    icAddPack,
    icAddPhoto,
    icSave,
    icSaveWhite,
    icSelectBlue,
    icTipGray,
    icTipBlue,
    icCheck,
    icCheckActive,
    icTranslation,
    icProfile,
    icHelp,
    icUploadPack,
    icAdditionalBrandList,
    icSelect,
    icSad,
    icNext,
    imgOrder,
    imgPayment,
    icAdditionalAttributes,
    icArrowLogin,
    icArrowRegister,
    imgPaymentFailed,
    icDrag,
    icOpenQuestion,
    icSingleChoice,
    icMultipleChoices,
    icNumbericScale,
    icSmileyRating,
    icStarRating,
    icDeleteAnswer,
    imgPaymentPending,
    imgLaugh,
    imgSmile,
    imgMeh,
    imgSad,
    imgPain,
    icPaymentHistory,
    imgPaymentError1,
    imgSupportAgent,
    imgDashboardReady,
    imgProjectScheduled,
    imgFieldworkInProgress,
    imgPriceTestProduct,
    imgPriceTestService,
    imgPriceTestProductImageExample,
    imgPriceTestServiceImageExample,
    icFiledownloadBlue,
    imgUploadFile,
    imgFileCsv,
    imgFileCsv2,
    imgPaymentSurvey,
    imgPaymentSurveyFail,
    icLiveSurvey,
    icSupportAgent,
    icSurveyCompleted,
    placeholderLogo,
    icFreeText,
    icLongText,
    icNumber,
    imgThankYou,
    starIcon,
    tagIcon,
    agreementIcon,
    importanceIcon,
    likelihoodIcon,
    sevenPointsIcon,
    tenPointsIcon,
    fivePointsIcon,
    imgSorry,
    basicAvatar,
    placeholderImage
}

export default images